import routes from '@/router/routes'
import {
  getMenuByRouter,
  getParentName
} from '@/libs/utils';
import {
  login,
  logOut
} from '@/libs/api';
import config from '@/config';

const message = {
    email: "",
    is_superuser: false,
    phone: "",
    user_id: 0,
    user_type: 0,
    username: "",
  },
  breadcrumb = [
  //   {
  //   meta: {
  //     title: config.title,
  //     href: config.href
  //   }
  // }
  // , {
  //   name: 'home',
  //   meta: {
  //     title: 'AI开放平台首页',
  //   }
  // }
];
export default {
  state: {
    root: "", //当前访问的根路由(children的同辈name)
    activeName: "", //当前激活的菜单
    access: [], //允许访问的权限列表
    hasGetInfo: false, //用户是否登录
    encryptType: [], //sdk加密方式
    sdkType: [], //sdk所属账户类型
    lang: 'zh-CN', //浏览语言
    choices: {
      scene_choices: [], //使用场景
      trade_choices: [] //使用行业
    },
    breadcrumb: [...breadcrumb], //面包屑数据
    pageSize: {
      navWidth: 230//菜单栏宽度
    },
    accountMessage: message//账号信息
  },
  getters: {
    menuList: (state, getters, rootState) => {
      const data = routes.filter(item => item.name === rootState.admin.root)[0];
      return getMenuByRouter(data && data.children.length > 0 && data.children || [], rootState.admin.access)
    }
  },
  mutations: {
    setRoot(state, routerItem) {
      state.root = getParentName(routerItem)
    },
    setActiveName(state, str) {
      state.activeName = str
    },
    setAccess(state, arr) {
      state.access = arr;
    },
    setHasGetInfo(state, bol) {
      state.hasGetInfo = bol
    },
    setEncryptType(state, arr) {
      state.encryptType = arr;
    },
    setSdkType(state, arr) {
      state.sdkType = arr;
    },
    setLang(state, str = 'zh-CN') {
      state.lang = str;
    },
    setBreadcrumb(state, arr) {
      state.breadcrumb = [...breadcrumb, ...arr];
    },
    setChoices(state, obj) {
      state.choices = Object.assign(state.choices, obj)
    },
    setPageSize(state, obj) {
      state.pageSize = Object.assign(state.pageSize, obj)
    },
    setAccountMessage(state, obj = message) {
      state.accountMessage = obj
    }
  },
  actions: {
    // 登录
    handleLogin({
      state,
      commit
    }, {
      username,
      password
    }) {
      return new Promise((resolve, reject) => {
        login(JSON.stringify({
          username,
          password
        })).then(res => {
          res = res.data;
          if (res.code === 1000) {
            sessionStorage.setItem("setAccountMessage", JSON.stringify(res.data));
            if (res.data.is_superuser || (!res.data.is_superuser && res.data.user_type === 2)) {
              let sdkTypeList = [],
                encrypt = [];
              for (const item of res.sdk_type_choices) {
                sdkTypeList.push({
                  id: item[0],
                  type: item[1]
                })
              }
              for (const item of res.encrypt_type_choices) {
                encrypt.push({
                  id: item[0],
                  type: item[1]
                })
              }
              commit('setSdkType', sdkTypeList)
              commit('setEncryptType', encrypt)
              if (res.data.is_superuser)
                commit('setAccess', ['admin']); else commit('setAccess', ['enterprise']);
            } else commit('setAccess', ['web']);
            commit('setAccountMessage', res.data)
            commit('setHasGetInfo', true)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 退出登录
    handleLogOut({
      state,
      commit
    }) {
      return new Promise((resolve, reject) => {
        const lang = state.lang
        logOut({lang}).then((res) => {
          res = res.data;
          if (res.code === 1000) {
            sessionStorage.removeItem("setAccountMessage");
            commit('setAccountMessage', message)
            commit('setAccess', [])
            commit('setHasGetInfo', false)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/module/admin.js